<div class="modal-header">
  <h5 class="modal-title" id="holdModalLabel">
    <i class="fas fa-hand-holding"></i> Holds
  </h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="holdForm" style="background-color: white; padding: 20px; border-radius: 5px;">

    <!-- Item Barcode Multi-Selection -->
    <div class="form-group">
      <label for="itemBarcodes">Item Barcodes:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select one or more items you wish to place on hold."></i>
      <ng-select id="itemBarcodes"
                 [items]="books$"
                 bindLabel="title"
                 bindValue="id"
                 formControlName="itemBarcodes"
                 placeholder="Select barcode(s)"
                 [multiple]="true"
                 [closeOnSelect]="false"
                 [clearable]="true"
                 [loading]="loading">
      </ng-select>
      <small class="text-muted">You can select multiple items at once.</small>
      <small class="text-danger d-block"
             *ngIf="submitted && holdForm.get('itemBarcodes').value?.length === 0">
        Please select at least one item.
      </small>
    </div>

    <!-- Member Name (single) -->
    <div class="form-group">
      <label for="memberName">Member Name:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select the member who is placing the hold."></i>
      <ng-select id="memberName"
                 [items]="members$"
                 bindLabel="firstname"
                 bindValue="id"
                 formControlName="memberName"
                 placeholder="Select a member">
      </ng-select>
      <small class="text-danger"
             *ngIf="submitted && holdForm.get('memberName').invalid">
        Member is required.
      </small>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
  <button type="button" class="btn btn-outline-primary" (click)="hold()">
    <i class="fas fa-hand-holding"></i> Hold
  </button>
</div>